<script>
    export default {
        /////////////////////////////////////////////////////
        // Data
        /////////////////////////////////////////////////////
        data() {
          return {}
        },
        mounted: function() {
          let video = this.$refs.videoRef
          video.play();
          video.addEventListener("timeupdate", () => {
            let currentTime = video.currentTime
            switch (true) {
              // Blank:
              case (currentTime > 0 && currentTime < 19):
                if (this.step !== 1) {
                  this.setStep(1)
                }
                break;
              // Step 19:
              case (currentTime > 19 && currentTime < 37):
                if (this.step !== 2) {
                  this.setStep(2)
                }
                break;
              // Blank:
              case (currentTime > 37 && currentTime < 50):
                if (this.step !== 3) {
                  this.setStep(3)
                }
                break;
              // Step 20:
              case (currentTime > 50 && currentTime < 60):
                if (this.step !== 4) {
                  this.setStep(4)
                }
                break;
              // Blank:
              case (currentTime > 60 && currentTime < 70):
                if (this.step !== 5) {
                  this.setStep(5)
                }
                break;
              // Step 21:
              case (currentTime > 70 && currentTime < 76):
                if (this.step !== 6) {
                  this.setStep(6)
                }
                break;
              // Blank:
              case (currentTime > 76 && currentTime < 80):
                if (this.step !== 7) {
                  this.setStep(7)
                }
                break;
              // Step 22:
              case (currentTime > 80 && currentTime < 85):
                if (this.step !== 8) {
                  this.setStep(8)
                }
                break;
              // Blank:
              case (currentTime > 85 && currentTime < 86):
                if (this.step !== 9) {
                  this.setStep(9)
                }
                break;
              // Step 23:
              case (currentTime > 86):
                if (this.step !== 10) {
                  this.setStep(10)
                }
                break;
            }
          })
        },
        watch: {
        },
        /////////////////////////////////////////////////////
        // Props
        /////////////////////////////////////////////////////
        props: {
            'step': {
                type: Number,
                default: 0
            },
            'dataLoaded': {
                type: Boolean,
                default: false
            }
        },
        /////////////////////////////////////////////////////
        // Methods
        /////////////////////////////////////////////////////
        methods: {
            nextPage() {
                if (this.step == 10) {
                    window.location = '09.html'
                }
            },
            prevPage() {
                if (this.step == 1) {
                    window.location = '07.html'
                }
            },
            setStep(step) {
              this.$emit('next', parseInt(step));
            },
            nextStep() {
                this.$emit('next', parseInt(this.step) + 1);
            },
            prevStep() {
                this.$emit('prev', parseInt(this.step) - 1);
            }
        }
    }

</script>
